import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";
const Content = ({ reportData, data, entity, title, printComponentRef, setIsPrinting, groupByMaterial }) => {
    return (
        <>
            { reportData && data && (
                <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setIsPrinting}>
                    <div className="w-full mt-[25px] print:mt-0 min-h-[calc(100vh-302px)]!">
                        <ReportContent data={reportData} groupByMaterial={groupByMaterial}/>
                    </div>
                </PrintTemplate>
            )}
        </>
    )
};

export default Content;